import { get, post, put } from '@/utils/request'

// 行政区接口
export const getRegionList = (params?) =>
  get<Record<string, any>[]>('/cost-cloud-support/region/list', params)

// 项目结构列表
export const getProjectStruct = (data?) =>
  get<any[]>('/cmp-indicator/cost_project/engineering_structure', data)
// 工程结构接口（批量）
export const getBatchProjectStructs = (data?) => get<any[]>('/cmp-indicator/cost_project/engineering_structures', data)

export const getNewProjectStruct = (data?) =>
  get<any[]>('/cmp-indicator/cost_project/engineering_structure_origin', data)

// 项目结构列表
export const getProjectStructQd = data =>
  get<any>(
    `/cost-cloud-indicator/cost_project/engineering_qd`, data
  )

// 工程结构接口（批量）
export const getBatchProjectStruct = params =>
  get<any>('/cost-cloud-indicator/cost_project/batch_engineering_structure', params)

// 造价指标附件保存接口
// NOTE: 项目组成的附件
export type CostAttachFileType = {
  extension: string // 后缀名
  fileId: string // 文件ID
  md5: string // 文件md5
  name: string // 文件的名称
  size: string // 文件大小
}
export const uploadCostAttach = (data: {
  itemList: CostAttachFileType[]
  relationId: string
  relationType: 1
}) =>
  post<{ id: string; resultState: boolean }>('/cost-cloud-indicator/attachment/full_create', data)

export interface AttachFileInfo {
  epid: number // 企业ID
  extension: string // 后缀名
  fileId: string // 文件ID
  id: string // 主键
  md5: string // 文件md5
  name: string // 文件的名称
  relationId: string // 关联业务ID
  relationType: number // 关联类型：1-造价文件项目信息
  size: number // 文件大小
  sort: number // 序号（1，2...）
}
export const getAttachDetail = (data: {
  id: string // 模板条目ID
}) => get<AttachFileInfo>('/cost-cloud-indicator/attachment/detail', data)

// 附件列表接口
export const getAttachList = (data: {
  relationIds: string | string[] // 关联业务ID
  relationType: 1 // 关联类型：1-造价文件项目信息
  pageIndex?: number // 分页索引,示例值(1)
  pageSize?: number // 分页条数,示例值(1000)
}) => get<{ result: AttachFileInfo[] }>('/cost-cloud-indicator/attachment/page', data)


// 初始化数据-检查接口
export const dataCheck = (data: any) => put<AttachFileInfo>('/cmp-indicator/init_data/check', data)

// 全局精度接口
export const getPrecisionSetting = (data: any) => get<any>('/cmp-indicator/precision_setting/page', data)
